import {Dispatch, FC, Fragment, SetStateAction, useEffect, useState} from 'react'
import axios from 'axios'
import {SearchSelectOption} from '../../../../../../../_metronic/helpers/components/SearchSelect'
import {API_URL} from '../../../../../../../_metronic/helpers'
import {Customer} from '../../../../customer-management/customers-list/core/_models'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'

type props = {
  basemode: number
  buyerSelected: {
    buyerSelected: SearchSelectOption | undefined
    setBuyerSelected: Dispatch<SetStateAction<SearchSelectOption | undefined>>
  }
  step: {
    step: number
    setStep: Dispatch<SetStateAction<number>>
  }
}

const SelectCustomer: FC<props> = ({basemode, buyerSelected, step}) => {
  const [first, setFirst] = useState(true)
  const [search, setSearch] = useState('')

  const [customerList, setCustomerList] = useState<Customer[]>()
  function getCustomer() {
    axios
      // Encoded: a search with «&» or «#» cut the address and asked for something else.
      .get(`${API_URL}/customers/query`, {params: {basemode, filter_search: search}})
      .then((response) => {
        setCustomerList(response.data.data)
      })
  }
  useEffect(() => {
    if (first) {
      getCustomer()
    }
  }, [])
  useEffect(() => {
    getCustomer()
  }, [search])
  return (
    <div>
      {!customerList && <div className='text-center'>در حال پردازش...</div>}
      <div className='row'>
        {customerList && (
          <>
            <div className='col-12'>
              <CustomInputs
                type='text'
                label='جستجوی خریدار'
                helpKey='ui.customerSearch'
                placeholder='جستجو...'
                stateValue={{
                  value: search,
                  setValue: setSearch,
                }}
              />
            </div>
            <div className='col-12'>
              {customerList.length > 0 ? (
                customerList.map((itm, ind) => {
                  return (
                    <div
                      key={ind}
                      className='border border-1 border-dashed border-primary d-flex flex-column bg-light-primary p-5 rounded my-3'
                      onClick={() => {
                        buyerSelected.setBuyerSelected({
                          value: itm.id,
                          label: itm.nm,
                        })
                        step.setStep(2)
                      }}
                    >
                      <div className='fs-2x link-primary'>{itm.nm}</div>
                      <div className='fs-5 text-gray-700'>{itm.nid}</div>
                    </div>
                  )
                })
              ) : (
                <div className='text-center'>خریداری یافت نشد.</div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export {SelectCustomer}
